import { ConfigChangeEvent } from '../models/campaign-config-audit.model';

const CAMPAIGN_PHASES_SOURCE = 'campaign_phases';

export function filterConfigChangeRowsByPhase(rows: ConfigChangeEvent[], phaseId: number | undefined): ConfigChangeEvent[] {
	if (phaseId === undefined) {
		return rows;
	}
	const filteredRows = rows.filter(row => row.source !== CAMPAIGN_PHASES_SOURCE || row.entity_id === phaseId);
	return filteredRows;
}
